import { render, staticRenderFns } from "./Partenaires.vue?vue&type=template&id=4b2c75cf&scoped=true&"
import script from "./Partenaires.vue?vue&type=script&lang=js&"
export * from "./Partenaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c75cf",
  null
  
)

export default component.exports